
import {Component, OnInit, QueryList, ViewChildren} from '@angular/core';
import {UIChart} from 'primeng/chart';
import {HttpClient} from '@angular/common/http';
import {DatePipe} from '@angular/common';
import {BaseClientComponent} from '../../base-client.component';
import {AuthenticationService} from '../../../authenticationModule/services/authentication.service';
import {GraphService} from '../../../services/graph.service';
import {UtilsService} from '../../../appSharedModule/services/utils.service';
import {BwGraphUserConfigs, BwGraphUserConfigsService} from '../../../generated';
import {ActivatedRoute} from '@angular/router';
import {SelectItem} from 'primeng/api';
import * as _ from 'lodash';
import {GraphType} from '../../../Enum/graph-type.enum';
import moment from 'moment-timezone';
import {environment} from '../../../../environments/environment';
import {GraphHandlerService} from '../graph-handler.service';
import {switchMap} from 'rxjs/operators';
import 'chartjs-adapter-moment';
import zoomPlugin from 'chartjs-plugin-zoom';
import {TechnicalPopService} from '../../../services/technical-pop.service';

const userPrefKey = 'userQhfPlrLatencyGraphPref';

@Component({
  selector: 'app-market-data-qhf-plr-latency-graph',
  templateUrl: './market-data-qhf-plr-latency-graph.component.html',
  styleUrl: './market-data-qhf-plr-latency-graph.component.scss'
})

export class MarketDataQhfPlrLatencyGraphComponent extends BaseClientComponent implements OnInit {
  @ViewChildren('chart') charts !: QueryList<UIChart>;

  channel2PopListSelect: any[] = [];
  savedUserFilterConfigs: SelectItem[] = [];
  selectedChannels2PopForList: any[] = [];
  loadedGraphs = [];
  selectedVlan: any[] = [];
  selectedChannels2Pop: any[] = [];
  channels2Pop: string[];
  timeZoneList = [];
  zoomOptions = [];
  periods = [];
  updateRoutesDisabled = true;
  loadingPrefs = true;
  noGraphs = false;
  zoomIn = false;
  showChangedConfigMessage = false;
  loadingGraphsStatus = false;
  refreshingGraphs = false;
  refreshingGraphIds = {};
  batchToLoad = 0;
  maxTime: number;
  minTime: number;
  batchedGraphs: any;
  userDefaultGraphsParams = {
    graphOption: {},
    selectedVvlans: [],
    selectedPeriod: {},
    zoomIn: false,
    timeZone: 'UTC',
    selectedConfiguration: null,
  };
  bwGraphUserDefaultConfig?: BwGraphUserConfigs;
  savedUserConfigs: Array<BwGraphUserConfigs>;
  checkboxesModel = {};
  graphData = {};
  graphStats = {};
  listObservable = {};
  readonly PLR_COLOR = '#2a78d6';
  readonly LATENCY_COLOR = '#199e70';
  private crosshairPlugin = {
    id: 'qhfPlrCrosshair',
    afterDraw: (chart: any) => {
      const activeElements = chart.tooltip && chart.tooltip.getActiveElements ? chart.tooltip.getActiveElements() : [];
      if (!activeElements.length) {
        return;
      }
      const x = activeElements[0].element.x;
      const ctx = chart.ctx;
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(x, chart.chartArea.top);
      ctx.lineTo(x, chart.chartArea.bottom);
      ctx.lineWidth = 1;
      ctx.strokeStyle = 'rgba(11, 11, 11, 0.28)';
      ctx.stroke();
      ctx.restore();
    }
  };
  chartPlugins = [zoomPlugin, this.crosshairPlugin];
  graphExecutionTimeOptions = {};
  defaultGraphExecutionTimeOptions = {};
  selectedPeriod: any = {};
  options: any;
  unit = 'hour';
  selectedTimeZone = 'UTC';
  selectedConfigurationId: string = null;
  selectedConfigurationName: string = null;

  constructor(public authenticationService: AuthenticationService,
              protected graphService: GraphService,
              protected utilsService: UtilsService,
              protected http: HttpClient,
              protected datePipe: DatePipe,
              protected technicalPopService: TechnicalPopService,
              private bwGraphUserConfigsService: BwGraphUserConfigsService,
              public route: ActivatedRoute,
              private graphHandlerService: GraphHandlerService) {
    super();
  }

  ngOnInit() {
    this.utilsService.lockUi();
    const response$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
      this.ngOnChanges();
    });
    this.subscriptions.push(response$);
    this.timeZoneList = this.graphHandlerService.timeZoneList;
    this.periods = this.graphHandlerService.periods;
    this.zoomOptions = this.graphHandlerService.zoomOptions;
  }

  ngOnChanges() {
    const response$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
      moment.tz.setDefault('UTC');
      const timeWindow = this.graphHandlerService.initMinAndMaxTime();
      this.minTime = timeWindow.minTime;
      this.maxTime = timeWindow.maxTime;
      this.initializeGraphExecutionTimeOption();
      this.getGraphInformation('channels2Pop', 'channels2PopList', 'qhf-plr-latency-graph-data');
    });
    this.subscriptions.push(response$);
  }

  resetFilters() {
    this.selectedVlan = [];
    this.selectedChannels2Pop = [];
    this.zoomIn = false;
    this.selectedTimeZone = 'UTC';
    this.selectedConfigurationId = null;
    this.selectedConfigurationName = null;
    _.forEach(this.channels2Pop, (channel2Pop) => {
      this.selectedChannels2Pop.push(channel2Pop);
      this.selectedPeriod[channel2Pop] = 360;
      this.graphExecutionTimeOptions[channel2Pop] = _.cloneDeep(this.defaultGraphExecutionTimeOptions);
    });
    this.selectedChannels2PopForList = this.createSelectedDataGraphList(this.channel2PopListSelect, this.selectedChannels2Pop);
    this.reinitializeCheckBoxModel(this.channels2Pop, this.selectedChannels2Pop);
    this.charts.map((chart: UIChart) => {
      chart.options.scales.x.max = null;
      chart.options.scales.x.time.unit = this.unit;
      chart.options.scales.x.min = this.minTime;
      chart.reinit();
    });
    this.updateDefaultConfiguration([this.bwGraphUserDefaultConfig], null);
    this.saveUserPrefs();
    this.showChangedConfigMessage = false;
    this.loadFirstBatch();
  }

  hideGraph(index) {
    this.checkboxesModel[index] = false;
    this.reinitializeSelectedVlan();
  }

  reinitializeSelectedVlan() {
    this.selectedChannels2Pop = [];
    _.forEach(this.checkboxesModel, (isSelected, index: string) => {
      if (isSelected === true) {
        this.selectedChannels2Pop.push(index);
      }
    });
    this.selectedChannels2PopForList = this.createSelectedDataGraphList(this.channel2PopListSelect, this.selectedChannels2Pop);
    this.saveUserPrefs();
  }

  loadSavedFilterConfiguration(configurationToLoad: BwGraphUserConfigs | null = null) {
    const UserSavedConfiguration = (!configurationToLoad) ? _.find(this.savedUserConfigs, {id: this.selectedConfigurationId}) as BwGraphUserConfigs : configurationToLoad;
    if (!configurationToLoad) {
      this.updateDefaultConfiguration([this.bwGraphUserDefaultConfig], UserSavedConfiguration);
    }
    this.userDefaultGraphsParams = _.cloneDeep(UserSavedConfiguration.config);
    this.selectedConfigurationName = _.clone(UserSavedConfiguration.configName);
    if (!this.userDefaultGraphsParams.graphOption) {
      _.forEach(this.channels2Pop, (channel2Pop) => {
        this.graphExecutionTimeOptions[channel2Pop] = _.cloneDeep(this.defaultGraphExecutionTimeOptions);
      });
    } else {
      this.graphExecutionTimeOptions = this.applyThemeToSavedOptions(this.userDefaultGraphsParams.graphOption);
      _.forEach(this.channels2Pop, (channel2Pop) => {
        if (!this.graphExecutionTimeOptions[channel2Pop]) {
          this.graphExecutionTimeOptions[channel2Pop] = _.cloneDeep(this.defaultGraphExecutionTimeOptions);
        }
      });
      this.selectedTimeZone = this.userDefaultGraphsParams.timeZone;
      moment.tz.setDefault(this.userDefaultGraphsParams.timeZone);
      if (this.userDefaultGraphsParams.selectedVvlans.length > 0) {
        this.selectedChannels2Pop = this.userDefaultGraphsParams.selectedVvlans;
        this.selectedChannels2PopForList = this.createSelectedDataGraphList(this.channel2PopListSelect, this.selectedChannels2Pop);
        _.forEach(this.selectedChannels2Pop, (selectedChannel2Pop) => {
          this.checkboxesModel[selectedChannel2Pop] = true;
        });
      }
    }
    this.zoomIn = this.userDefaultGraphsParams.zoomIn;
    if (this.userDefaultGraphsParams.selectedPeriod) {
      this.selectedPeriod = this.userDefaultGraphsParams.selectedPeriod;
    }
    this.loadingPrefs = false;
    this.loadFirstBatch();
    this.charts.map((chart: UIChart) => {
      if (this.graphExecutionTimeOptions[chart.data.id]) {
        chart.options = this.graphExecutionTimeOptions[chart.data.id];
        chart.reinit();
      }
    });
    this.saveUserPrefs();
    this.showChangedConfigMessage = false;
  }

  private applyThemeToSavedOptions(savedOptionsByGraph: any): any {
    return this.graphHandlerService.applyThemeToSavedOptions(savedOptionsByGraph, this.defaultGraphExecutionTimeOptions);
  }

  updateTimeScale(index) {
    this.graphHandlerService.applyTimeScaleUpdate(index, this.charts, this.selectedPeriod, this.minTime, this.userDefaultGraphsParams, () => this.saveUserDataInfo());
  }

  resetCharZoom(vvlan) {
    this.graphHandlerService.applyResetZoom(vvlan, this.charts, this.selectedPeriod, this.minTime, this.maxTime);
    this.saveUserPrefs();
  }

  saveUserPrefs(loadSelectedGraphs = false) {
    const result = this.graphHandlerService.saveUserPrefs(
      this.userDefaultGraphsParams,
      this.charts,
      this.selectedChannels2PopForList,
      this.selectedChannels2Pop,
      this.selectedPeriod,
      this.zoomIn,
      this.selectedConfigurationId,
      this.selectedTimeZone
    );
    this.userDefaultGraphsParams = result.userDefaultGraphsParams;
    this.showChangedConfigMessage = result.showChangedConfigMessage;
    this.updateRoutesDisabled = result.updateRoutesDisabled;
    this.charts = result.charts;
    this.saveUserDataInfo();
    this.reinitializeCheckBoxModel(this.channels2Pop, this.selectedChannels2Pop);
    if (loadSelectedGraphs) {
      this.loadFirstBatch();
    }
    this.saveUserDataInfo();
  }

  private initializeUserDefaultGraphsParams(selectedIndex) {
    this.userDefaultGraphsParams.selectedVvlans = selectedIndex;
    this.userDefaultGraphsParams.selectedConfiguration = this.selectedConfigurationId;
    this.userDefaultGraphsParams.timeZone = this.selectedTimeZone;
    this.saveUserDataInfo();
    this.loadingPrefs = false;
    this.showChangedConfigMessage = false;
  }

  onSelect() {
    this.selectedChannels2PopForList = this.createSelectedDataGraphList(this.channel2PopListSelect, this.selectedChannels2Pop);
    this.updateRoutesDisabled = this.selectedChannels2PopForList.length === 0;
  }

  loadDefaultUserPrefGraph() {
    this.loadingPrefs = true;
    const savedParams = this.utilsService.getUserData(userPrefKey);
    if (!savedParams) {
      _.forEach(this.channels2Pop, (markets2TransportOrChannels2Pop) => {
        this.graphExecutionTimeOptions[markets2TransportOrChannels2Pop] = _.cloneDeep(this.defaultGraphExecutionTimeOptions);
        this.selectedChannels2Pop.push(markets2TransportOrChannels2Pop);
        this.checkboxesModel[markets2TransportOrChannels2Pop] = true;
      });
      this.selectedChannels2PopForList = this.createSelectedDataGraphList(this.channel2PopListSelect, this.selectedChannels2Pop);
      this.initializeUserDefaultGraphsParams(this.selectedChannels2Pop);
      return;
    }
  }

  public loadFirstBatch() {
    this.batchToLoad = 0;
    const selectedData = this.selectedChannels2Pop;
    this.batchedGraphs = _.chunk(selectedData, this.graphHandlerService.INFINIT_SCROLL_BATCH_SIZE);
    _.forEach(this.batchedGraphs[0], (index: string) => {
      this.loadGraphPlrLatencyGraph(index);
    });
    this.batchToLoad++;
  }

  public loadNextBatch() {
    if (this.batchedGraphs && this.batchToLoad < this.batchedGraphs.length) {
      const currentBatch = this.batchedGraphs[this.batchToLoad];
      const graphsToLoad = currentBatch.slice(0, 4); // Load a maximum of 4 graphs from the current batch
      graphsToLoad.forEach((index: string) => {
        this.loadGraphPlrLatencyGraph(index);
      });
      this.batchToLoad++;
    }
  }

  reinitializeCheckBoxModel(data, selectedData) {
    this.graphHandlerService.reinitializeCheckBoxModel(data, selectedData, this.checkboxesModel);
  }

  public saveFilterConfig() {
    this.saveUserPrefs();
    const configuration = _.find(this.savedUserFilterConfigs, {'label': this.selectedConfigurationName});
    if (configuration) {
      this.updateFilterConfiguration(configuration.value);
    } else {
      this.createNewFilterConfiguration();
    }
  }

  changeTimeZone() {
    this.selectedTimeZone = this.graphHandlerService.applyTimeZoneChange(this.selectedTimeZone, this.charts);
    this.saveUserPrefs();
  }

  public initSavedConfigs() {
    this.savedUserFilterConfigs = [];
    this.savedUserConfigs = this.authenticationService.userCurrent.bwGraphUserConfigs.filter(userConfig => userConfig.type === GraphType.MARKET_DATA_QHF_PLR_LATENCY);
    _.forEach(this.savedUserConfigs, (savedUserConfig: BwGraphUserConfigs) => {
      if (savedUserConfig.type === GraphType.MARKET_DATA_QHF_PLR_LATENCY) {
        this.savedUserFilterConfigs.push({
          label: savedUserConfig.configName, value: savedUserConfig.id,
        });
      }
    });
    this.savedUserFilterConfigs.sort((a, b) => a.label.localeCompare(b.label));
    if (this.authenticationService.userCurrent.bwGraphUserDefaultConfig && this.authenticationService.userCurrent.bwGraphUserDefaultConfig.filter(userDefaultConfig => userDefaultConfig.type === GraphType.MARKET_DATA_QHF_PLR_LATENCY).length > 0) {
      const defaultConfig = this.authenticationService.userCurrent.bwGraphUserDefaultConfig.filter(userDefaultConfig => userDefaultConfig.type === GraphType.MARKET_DATA_QHF_PLR_LATENCY);
      this.bwGraphUserDefaultConfig = _.find(this.authenticationService.userCurrent.bwGraphUserConfigs, {'id': defaultConfig[0]['id']});
      this.selectedConfigurationId = (this.bwGraphUserDefaultConfig) ? this.bwGraphUserDefaultConfig.id : null;
    }
  }

  updateFilterConfiguration(configurationId: string) {
    const configuration = this.utilsService.loadUserPref(userPrefKey);
    const graphConfiguration = <BwGraphUserConfigs>{
      configName: this.selectedConfigurationName,
      config: configuration,
      type: GraphType.MARKET_DATA_QHF_PLR_LATENCY,
      isDefault: true,
    };
    this.bwGraphUserConfigsService.putBwGraphUserConfigsItem(configurationId, graphConfiguration)
      .subscribe({
        next: (config) => {
          this.authenticationService.userCurrent.bwGraphUserConfigs.map((item) => {
            if (item.id === configurationId) {
              item = config;
            }
          });
          this.showChangedConfigMessage = false;
        }, error: (error) => {
          this.utilsService.handleErrorWebservice$(error);
        }
      });
  }

  createNewFilterConfiguration() {
    const configuration = this.utilsService.loadUserPref(userPrefKey);
    const graphConfiguration = <BwGraphUserConfigs>{
      configName: this.selectedConfigurationName,
      config: configuration,
      user: '/api/users/' + this.authenticationService.userCurrent.id,
      createdBy: this.authenticationService.userCurrent.email,
      type: GraphType.MARKET_DATA_QHF_PLR_LATENCY,
      isDefault: true,
    };
    this.bwGraphUserConfigsService.postBwGraphUserConfigsCollection(graphConfiguration).subscribe({
      next: (config) => {
        this.authenticationService.userCurrent.bwGraphUserConfigs.push(config);
        this.updateDefaultConfiguration(this.authenticationService.userCurrent.bwGraphUserConfigs, config);
        this.initSavedConfigs();
      }, error: (error) => {
        this.utilsService.handleErrorWebservice$(error);
      }
    });
  }

  isDisplayedData(index: string) {
    if (!this.selectedChannels2Pop) {
      return true;
    }
    return this.selectedChannels2Pop.some(selected => String(selected) === String(index));
  }

  reloadCharts(index) {
    this.charts.map((chart: UIChart) => {
      if (chart.data.id === index) {
        this.userDefaultGraphsParams.graphOption[index] = chart.options;
        this.utilsService.saveUserData(userPrefKey, this.userDefaultGraphsParams);
        chart.reinit();
      }
    });
  }

  getGraphLegend(index: string) {
    const list = this.channel2PopListSelect;
    const data = list.filter(channel => channel.value === index);
    if (data.length === 0) {
      return index;
    }
    if (data.length === 1) {
      return data[0].label;
    }
    // This is a turn around to display two different graphs that have the same index but not the same title.
    if (data[0].displayed === data[1].displayed) {
      data[0].displayed = !data[0].displayed;
      return data[0].label;
    }
    data[1].displayed = !data[1].displayed;
    return data[1].label;
  }

  getTechnicalPopFromLabel(index: string) {
    return this.graphHandlerService.extractTechnicalPop(this.getGraphLegend(index), /@(.{3})/);
  }

  private initializeGraphExecutionTimeOption() {
    this.defaultGraphExecutionTimeOptions = this.graphHandlerService.getThemedGraphExecutionTimeOptions(this.onZoomComplete.bind(this));
    this.defaultGraphExecutionTimeOptions['scales'] = this.graphHandlerService.setThemedPlrLatencyScales(this.minTime, this.unit, this.maxTime);
    this.options = this.graphHandlerService.getCommonOption();
  }

  private onZoomComplete(chart: any): void {
    this.graphHandlerService.applyZoomComplete(this.graphExecutionTimeOptions, chart, () => this.saveUserPrefs());
  }

  private getGraphInformation(data, dataList, heartbeatOrQrdMlr) {
    this.graphHandlerService.loadUserConfigs().pipe(
      switchMap(() => this.graphService.getHeartbeatOrQrdMlrGraphsInformation(heartbeatOrQrdMlr))
    ).subscribe(res => {
      this.channels2Pop = res[data];
      this.channel2PopListSelect = res[dataList].sort((a, b) => a.label.localeCompare(b.label));
      this.initializeDataGraph(this.channels2Pop);
      this.utilsService.unlockUi();
    });
  }

  private initializeDataGraph(graphInformation: string[]) {
    if (!graphInformation || graphInformation.length <= 0) {
      this.noGraphs = true;
    } else {
      _.forEach(graphInformation, (data) => {
        this.selectedPeriod[data] = 360;
        this.checkboxesModel[data] = false;
      });
      this.initSavedConfigs();
      if (this.selectedConfigurationId) {
        this.loadSavedFilterConfiguration(this.bwGraphUserDefaultConfig);
      } else {
        this.utilsService.removeUserData(userPrefKey);
        this.loadDefaultUserPrefGraph();
      }
      this.loadFirstBatch();
    }
  }

  private updateDefaultConfiguration(oldConfigurations: Array<BwGraphUserConfigs>, newConfiguration: BwGraphUserConfigs = null) {
    _.forEach(oldConfigurations, (oldConfiguration: BwGraphUserConfigs) => {
      if (oldConfiguration && oldConfiguration.type === GraphType.MARKET_DATA_QHF_PLR_LATENCY) {
        this.bwGraphUserConfigsService.putBwGraphUserConfigsItem(oldConfiguration.id, {isDefault: false}).subscribe();
        this.bwGraphUserDefaultConfig = null;
      }
    });

    if (newConfiguration && newConfiguration.type === GraphType.MARKET_DATA_QHF_PLR_LATENCY) {
      this.bwGraphUserConfigsService.putBwGraphUserConfigsItem(newConfiguration.id, {isDefault: true})
        .subscribe({
          next: (result: BwGraphUserConfigs) => {
            this.bwGraphUserDefaultConfig = result;
            this.selectedConfigurationId = result.id;
            this.showChangedConfigMessage = false;
          }, error: (error) => {
            this.utilsService.handleErrorWebservice$(error);
          }
        });
    } else {
      this.authenticationService.userCurrent.bwGraphUserDefaultConfig = null;
    }
  }

  private reanchorRelativeTimeWindow(index: string) {
    this.graphHandlerService.reanchorRelativeTimeWindow(index, this.selectedPeriod, this.graphExecutionTimeOptions);
  }

  refreshGraphsData() {
    const routesToRefresh = _.filter(this.channels2Pop, (route) => this.listObservable[route] && this.isDisplayedData(route));
    if (routesToRefresh.length === 0) {
      return;
    }
    this.refreshingGraphs = true;
    let remaining = routesToRefresh.length;
    const onRouteDone = () => {
      remaining--;
      if (remaining <= 0) {
        this.refreshingGraphs = false;
      }
    };
    _.forEach(routesToRefresh, (route) => this.loadGraphPlrLatencyGraph(route, true, onRouteDone));
  }

  refreshSingleGraph(index) {
    if (this.refreshingGraphIds[index]) {
      return;
    }
    this.refreshingGraphIds[index] = true;
    this.loadGraphPlrLatencyGraph(index, true, () => {
      this.refreshingGraphIds[index] = false;
    });
  }

  private exportFileName(index: string, extension: string) {
    return this.graphHandlerService.buildExportFileName(this.getGraphLegend(index), '-plr-latency-', extension);
  }

  exportCsv(index: string) {
    this.graphHandlerService.exportTwoSeriesCsv(this.graphData, index, 'PLR', this.exportFileName(index, 'csv'));
  }

  exportPng(index: string) {
    this.graphHandlerService.exportChartPng(this.charts, index, this.exportFileName(index, 'png'));
  }

  private loadGraphPlrLatencyGraph(channel2Pop: string, forceRefresh = false, onComplete?: () => void) {
    this.loadingGraphsStatus = true;
    if (!channel2Pop) {
      if (onComplete) {
        onComplete();
      }
      return;
    }
    if (!this.isDisplayedData(channel2Pop)) {
      this.loadingGraphsStatus = false;
      if (onComplete) {
        onComplete();
      }
      return;
    }
    if (this.graphData[channel2Pop] && !forceRefresh) {
      this.loadingGraphsStatus = false;
      this.loadedGraphs.push(channel2Pop);
      if (onComplete) {
        onComplete();
      }
      return;
    }
    if (!forceRefresh) {
      this.loadedGraphs.push(channel2Pop);
    }
    this.listObservable[channel2Pop] = this.http.get<any>(environment.baseUrlWs + '/api/qhf-plr-latency-graph?qhfChannelOrderId=' + channel2Pop).subscribe({
      next: (response: any) => {
        this.graphHandlerService.applyTwoSeriesGraphResponse(
          response, channel2Pop, 'PLR', this.PLR_COLOR, this.LATENCY_COLOR,
          this.graphData, this.graphStats, this.charts, forceRefresh,
          (idx) => this.reanchorRelativeTimeWindow(idx)
        );
        this.loadingGraphsStatus = false;
        if (onComplete) {
          onComplete();
        }
      }, error: () => {
        this.graphHandlerService.applyGraphLoadError(this.graphData, channel2Pop);
        this.loadingGraphsStatus = false;
        if (onComplete) {
          onComplete();
        }
      }
    });
  }

  private saveUserDataInfo() {
    this.utilsService.saveUserData(userPrefKey, this.userDefaultGraphsParams);
  }

  private createSelectedDataGraphList(dataGraphListSelect, selectedDataGraph) {
    return this.graphHandlerService.createSelectedDataGraphList(dataGraphListSelect, selectedDataGraph);
  }
}
